var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"detail container-fluid"},[_c('b-row',[_c('b-col',{staticClass:"col-lg-12",attrs:{"lg":"12"}},[_c('div',{staticClass:"trending-info g-border"},[_c('h1',{staticClass:"trending-text big-title text-uppercase mt-0"})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }